/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBackfillUserChannelsResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type BackfillUserChannelsResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/salesreps/backfill-user-channels
 */
export interface BackfillUserChannelsRequestBuilder extends BaseRequestBuilder<BackfillUserChannelsRequestBuilder> {
    /**
     * Grants each Sales Rep sync user in the organization their per-identity access to orders and carts. Safe to run repeatedly — grants are idempotent, reps with no identity provider user id are skipped, and a failed rep does not stop the run, so re-running heals it.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BackfillUserChannelsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BackfillUserChannelsResponse | undefined>;
    /**
     * Grants each Sales Rep sync user in the organization their per-identity access to orders and carts. Safe to run repeatedly — grants are idempotent, reps with no identity provider user id are skipped, and a failed rep does not stop the run, so re-running heals it.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BackfillUserChannelsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/salesreps/backfill-user-channels";
/**
 * Metadata for all the requests in the request builder.
 */
export const BackfillUserChannelsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BackfillUserChannelsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBackfillUserChannelsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
